import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function ExpertQuote() {
  return <section className="w-full py-12 px-4" data-id="element-68">
      <div className="max-w-3xl mx-auto" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative px-8 py-10" data-id="element-70">
          <Quote className="absolute top-0 left-0 w-12 h-12 text-brown/20 rotate-180" data-id="element-71" />

          <blockquote className="font-serif text-xl md:text-2xl text-gray-800 leading-relaxed text-center italic relative z-10" data-id="element-72">
            "Eine verlangsamte Darmpassage führt dazu dass Giftstoffe länger im
            Körper verbleiben und resorbiert werden. Ballaststoffe – besonders
            die Kombination aus löslichen und unlöslichen – sind die effektivste
            natürliche Methode die Darmpassage zu normalisieren."
          </blockquote>

          <div className="mt-6 text-center" data-id="element-73">
            <p className="font-handwriting text-2xl text-forest font-bold" data-id="element-74">
              – Dr. Nane Schomburg
            </p>
            <p className="font-serif text-sm text-brown" data-id="element-75">Tierärztin</p>
          </div>

          <Quote className="absolute bottom-0 right-0 w-12 h-12 text-brown/20" data-id="element-76" />
        </motion.div>
      </div>
    </section>;
}